//src/pages/TaskList.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useFetch from '../../hooks/useFetch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlus, faSearch, faSlidersH } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const TaskList = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const location = useLocation();
  const [tasks, setTasks] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [name, setName] = useState('');
  const [place, setPlace] = useState('');
  const [tags, setTags] = useState('');
  const [purpose, setPurpose] = useState('');
  const [purposeHead, setPurposeHead] = useState('');
  const purposeInitialized = useRef(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Digital Income");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sheearns");
  };

  const [filters, setFilters] = useState({
    otherUserCode: "",
    cardHolderCode: "",
    pairCode: "",
    teamCode: "",
    rcaCode: "",
    taskCode: "",
    taskLinkCode: "",
    projectCode: "",
    processCode: "",
    factoryCode: "",
    kaizenCode: "",
    ikigaiCode: "",
    sugoCode: "",
    lifeChunkCode: "",
    taskGroupCode: "",
  });
  const [showSearch, setShowSearch] = useState(false);

  const toggleSearch = () => setShowSearch((prev) => !prev);

  const toggleFilters = () => setShowFilters(!showFilters);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    document.title = authState.isLoggedIn ? `${authState.user.name}'s Chronicles` : "Think5Whys";
  }, [authState]);


  const purposeFromRoute = (location?.pathname || '').split('/').pop() || '';
  useEffect(() => {
    if (purposeFromRoute && !purposeInitialized.current) {
      let updatedPurpose = '';
      let purposeHead = '';
      switch (purposeFromRoute) {
        case 'attendance-list':
          updatedPurpose = 'Attendance';
          purposeHead = "Attendance";
          break;
        case 'budget-list':
          updatedPurpose = 'Budget';
          purposeHead = "Budget";
          break;    
        case 'budget-list':
          updatedPurpose = 'Budget';
          purposeHead = "Budget";
          break;  
        case 'petty-account-list':
          updatedPurpose = 'Petty-Account';
          purposeHead = "Petty-Account";
          break;
        case 'loans-list':
          updatedPurpose = 'Loans';
          purposeHead = "Loans";
          break;
        case 'assets-list':
          updatedPurpose = 'Assests';
          purposeHead = "Assets";
          break;
        case 'investments':
          updatedPurpose = 'Investments';
          purposeHead = "Investments";
          break;   
        case 'buy-list':
          updatedPurpose = 'Buy';
          purposeHead = "Order / Buy / Purchase";
          break;          
        case 'checklist-list':
          updatedPurpose = 'Checklist';
          purposeHead = "Checklist";
          break;  
        case 'dreams-list':
          updatedPurpose = 'Dream';
          purposeHead = "Dream";
          break;
        case 'environment-list':
          updatedPurpose = 'Environment';
          purposeHead = "Environment";
          break;
        case 'feelings-list':
          updatedPurpose = 'Feeling';
          purposeHead = "Feeling";
          break;  
        case 'mood-list':
          updatedPurpose = 'Mood';
          purposeHead = "Mood";
            break;  
        case 'gardening-list':
          updatedPurpose = 'Gardening';
          purposeHead = "Gardening";
          break;
        case 'gift-list':
          updatedPurpose = 'Gift';
          purposeHead = "Gift";
          break;
        case 'meditation-list':
          updatedPurpose = 'Meditation';
          purposeHead = "Meditation";
          break;       
        case 'exercise-list':
          updatedPurpose = 'Exercise';
          purposeHead = "Exercise";
          break;       
        case 'cooking-list':
          updatedPurpose = 'Cooking';
          purposeHead = "Cooking";
          break;
        case 'todo-list':
          updatedPurpose = 'ToDo';
          purposeHead = "ToDo";
          break;
        case 'travels-list':
          updatedPurpose = 'Travel';
          purposeHead = "Travel";
          break;          
        case 'calendar-list':
          updatedPurpose = 'Calendar';
          purposeHead = "Calendar";
          break;     
        case 'planner-list':
          updatedPurpose = 'Planner';
          purposeHead = "Planner";
          break;     
        case 'planner-list':
          updatedPurpose = 'Planner';
          purposeHead = "Planner";
          break;           
        case 'events-list':
          updatedPurpose = 'Event';
          purposeHead = "Events";
          break;
        case 'empathy-list':
          updatedPurpose = 'Empathy';
          purposeHead = "Empathy";
          break;
        case 'experience-list':
          updatedPurpose = 'Experience';
          purposeHead = "Experience";
          break;
        case 'food-list':
          updatedPurpose = 'Food';
          purposeHead = "Food";
          break;
        case 'goals-list':
          updatedPurpose = 'Goal';
          purposeHead = "Goal";
          break;
        case 'gym-list':
          updatedPurpose = 'Gym';
          purposeHead = "Gym";
          break;
        case 'yoga-list':
          updatedPurpose = 'Yoga';
          purposeHead = "Yoga";
          break;          
        case 'gratitude-list':
          updatedPurpose = 'Gratitude';
          purposeHead = "Gratitude";
          break;
        case 'invitations-list':
          updatedPurpose = 'Invitations';
          purposeHead = "Invitations";
          break;
        case 'issues-list':
          updatedPurpose = 'Issues';
          purposeHead = "Issues";
          break;
        case 'medicine-list':
          updatedPurpose = 'Medicine';
          purposeHead = "Medicine";
          break;
        case 'meetings-list':
          updatedPurpose = 'Meeting';
          purposeHead = "Meeting";
          break;        
        case 'monthly-essentials-plan-list':
          updatedPurpose = 'Monthly-Essentials-Plan';
          purposeHead = "Monthly-Essentials-Plan";
          break;    
        case 'accountingjournal-list':
          updatedPurpose = 'Accounting-Journal';
          purposeHead = "Accounting-Journal ";
        break;
        case 'bills-list':
          updatedPurpose = 'Sales';
          purposeHead = "Bills";
        break;    
        case 'digitaltime-list':
          updatedPurpose = 'Digital-Time';
          purposeHead = "Digital-Time";
        break; 
        case 'estimates-list':
          updatedPurpose = 'Sales';
          purposeHead = "Estimates";
        break;    
        case 'receipts-list':
          updatedPurpose = 'Sales';
          purposeHead = "Receipts";
        break;         
        case 'gst-list':
          updatedPurpose = 'Sales';
          purposeHead = "GST-Bills";
        break;         
        case 'countersales-list':
          updatedPurpose = 'Retail Sales';
          purposeHead = "Counter-RetailSales";
          break;
        case 'kot-list':
          updatedPurpose = 'KOT';
          purposeHead = "KOT";
          break;
        case 'takeaway-list':
          updatedPurpose = 'Takeaway';
          purposeHead = "Takeaway";
          break;
        case 'onsitework-list':
          updatedPurpose = 'Onsite-Work';
          purposeHead = "Onsite-Work";
          break;
        case 'notesmemo-list':
          updatedPurpose = 'Notes';
          purposeHead = "Notes";
          break;
        case 'grocery-list':
          updatedPurpose = 'Grocery';
          purposeHead = "Grocery";
          break;
        case 'illness-list':
          updatedPurpose = 'Illness';
          purposeHead = "Illness";
          break;
        case 'jobless-list':
          updatedPurpose = 'Jobless';
          purposeHead = "Jobless";
          break;
        case 'memories-list':
          updatedPurpose = 'Memory';
          purposeHead = "Memory";
          break;
        case 'missed-opportunities-list':
          updatedPurpose = 'Missed-opportunities';
          purposeHead = "Missed-Opportunities";
          break;
        case 'physicalgrowth-list':
          updatedPurpose = 'Physical-Growth';
          purposeHead = "Physical-Growth";
        break; 
        case 'pet-list':
          updatedPurpose = 'Pet';
          purposeHead = "Pet";
          break;
        case 'play-sports-list':
          updatedPurpose = 'Play-Sports';
          purposeHead = "Play-Sports";
          break;
        case 'entertainment-list':
          updatedPurpose = 'Entertainment';
          purposeHead = "Entertainment";
          break;
        case 'regrets-list':
          updatedPurpose = 'Regret';
          purposeHead = "Regret";
          break;
        case 'routine-diet-list':
          updatedPurpose = 'Routine-Diet';
          purposeHead = "Routine-Diet";
          break;
        case 'routine-study-list':
          updatedPurpose = 'Routine-Study';
          purposeHead = "Routine-Study";
          break;
        case 'routine-others-list':
          updatedPurpose = 'Routine-Others';
          purposeHead = "Routine-Others";
          break;  
        case 'salary-list':
          updatedPurpose = 'Salary';
          purposeHead = "Salary";
          break;    
        case 'sales-list':
          updatedPurpose = 'Sales';
          purposeHead = "Sales";
          break;    
        case 'service-list':
          updatedPurpose = 'Service';
          purposeHead = "Service";
          break;  
        case 'socialactivity-list':
          updatedPurpose = 'Social-Activity';
          purposeHead = "Social-Activity";
          break;            
        case 'study-list':
          updatedPurpose = 'Study';
          purposeHead = "Study";
          break;
        case 'subscription-list':
          updatedPurpose = 'Subscription';
          purposeHead = "Subscription";
          break;          
        case 'sympathy-list':
          updatedPurpose = 'Sympathy';
          purposeHead = "Sympathy";
          break;
        case 'tasks-list':
          updatedPurpose = 'Task';
          purposeHead = "Tasks";
          break;
        case 'training-list':
          updatedPurpose = 'Training';
          purposeHead = "Training";
          break;
        case 'visits-list':
          updatedPurpose = 'Visit';
          purposeHead = "Visit";
          break;
        case 'waste-list':
          updatedPurpose = 'Waste';
          purposeHead = "Waste";
          break;
        case 'expense-list':
          updatedPurpose = 'Expense';
          purposeHead = "Expense";
          break;
        case 'income-list':
          updatedPurpose = 'Income';
          purposeHead = "Income";
          break;
        case 'assets-list':
          updatedPurpose = 'Assets';
          purposeHead = "Assets";
          break;
        case 'loans-list':
          updatedPurpose = 'Loans';
          purposeHead = "Loans";
          break;
        case 'investments-list':
          updatedPurpose = 'Investments';
          purposeHead = "Investments";
          break;
        case 'unspecified-list':
          updatedPurpose = 'Unspecified';
          purposeHead = "Unspecified";
          break;
        case 'vaccination-list':
          updatedPurpose = 'Vaccination';
          purposeHead = "Vaccination";
          break;          
        case 'thoughts-list':
          updatedPurpose = 'Thoughts';
          purposeHead = "Thoughts";
          break;  

        case 'crop-observation-list':
          updatedPurpose = 'Crop Observations';
          purposeHead = "Crop Observations";
          break;

        case 'sowing-list':
          updatedPurpose = 'Sowing';
          purposeHead = "Sowing";
          break;

        case 'tilling-list':
          updatedPurpose = 'Tilling';
          purposeHead = "Tilling";
          break;

        case 'irrigation-list':
          updatedPurpose = 'Irrigation';
          purposeHead = "Irrigation";
          break;

        case 'weeding-list':
          updatedPurpose = 'Weeding';
          purposeHead = "Weeding";
          break;

        case 'fertilizer-list':
          updatedPurpose = 'Fertilizer';
          purposeHead = "Fertilizer";
          break;

        case 'breakfast-list':
          updatedPurpose = 'Breakfast';
          purposeHead = "Breakfast";
          break;

        case 'pest-control-list':
          updatedPurpose = 'Pest Control';
          purposeHead = "Pest Control";
          break;

        case 'harvesting-list':
          updatedPurpose = 'Harvesting';
          purposeHead = "Harvesting";
          break;

        case 'repair-list':
          updatedPurpose = 'Repair';
          purposeHead = "Repair";
          break;

        case 'transporting-fodder-list':
          updatedPurpose = 'Transporting Fodder';
          purposeHead = "Transporting Fodder";
          break;

        case 'feeding-catle-list':
          updatedPurpose = 'Feeding Catle';
          purposeHead = "Feeding Catle";
          break;

        case 'animal-health-check-list':
          updatedPurpose = 'Animal Health Check';
          purposeHead = "Animal Health Check";
          break;

        case 'mandi-rate-list':
          updatedPurpose = 'Mandi Rate';
          purposeHead = "Mandi Rate";
          break;

        case 'weather-record-list':
          updatedPurpose = 'Weather Record';
          purposeHead = "Weather Record";
          break;
        case 'eyewear-record-list':
          updatedPurpose = 'Eyewear Record';
          purposeHead = "Eyewear Record";
          break;          
        default:
          updatedPurpose = 'Task';
          purposeHead = "Tasks";
          break;
      }
      setPurpose(updatedPurpose);
      setPurposeHead(purposeHead);
      purposeInitialized.current = true;
    }
  }, [location.pathname]);

  const fetchTasks = useCallback((purpose) => {
    if (!purpose) {
      return;
    }
  
    let searchParam = 1;
    let config = {};
  
    if (
      purposeFromRoute === 'mypetty-account' ||
      purposeFromRoute === 'myloans' ||
      purposeFromRoute === 'myasset' ||
      purposeFromRoute === 'myinvestments'
    ) {
      let lrType = '';
  
      if (purposeFromRoute === 'mypetty-account') {
        lrType = "Income & Expense";
      } else if (purposeFromRoute === 'myloans') {
        lrType = "LoanGiven & LoanTaken";
      } else if (purposeFromRoute === 'myassets') {
        lrType = "Asset";
      } else if (purposeFromRoute === 'investments') {
        lrType = "Investment";
      } else {
        lrType = "NA";
      } 
  
      config = {
        url: "/tasks/mytasks",
        method: "post",
        headers: { Authorization: authState.token },
        data: { userId: authState.user._id, purpose: purpose, lrType: lrType }
      };
    } else {
      config = {
        url: "/tasks/mytasks",
        method: "post",
        headers: { Authorization: authState.token },
        data: { userId: authState.user._id, purpose: purpose, lrType: null }
      };
    }  
    fetchData(config, { showSuccessToast: false }).then(data => setTasks(data.tasks));
  }, [authState.token, fetchData, authState.user._id, purposeFromRoute]);
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchTasks(purpose);
  }, [authState.isLoggedIn, fetchTasks, purpose]);

  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  
  const deleteClicked = () => {
    setIsDeleteClicked(true);
  }
  
  const noDeleteClicked = () => {
    setIsDeleteClicked(false);
  }

  const handleDelete = (id) => {
    const config = {
      url: `/tasks/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => fetchTasks(purpose));
  }

  const handleView = (taskId) => {
    setSelectedTaskId(prevId => (prevId === taskId ? null : taskId));
  };

  const handleCloseTaskDetails = () => {
    setSelectedTaskId(null);
  };

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const handleSearch = () => {
    // Implement search functionality
  };

  const handleTaskClick = (taskId) => {
    setSelectedTaskId(taskId);
  };

  const handleTaskShare = (taskId) => {
    setSelectedTaskId(taskId);
  };

  const handleTaskSave = (taskId) => {
    setSelectedTaskId(taskId);
  };

  const handleTaskPrint = (taskId) => {
    setSelectedTaskId(taskId);
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  const sortedTasks = [...tasks].sort((a, b) => new Date(b.taskDate) - new Date(a.taskDate));

  return (
  <div className="min-h-screen flex flex-col bg-black text-blue-100 font-sans [&_p]:text-white">
    <header className="sticky top-0 z-50 bg-black border-b border-blue-800 px-4 py-2 flex items-center justify-between shadow-lg">
      <div className="flex flex-col">
        <div className="text-xl lg:text-2xl font-bold text-yellow-200">{purposeHead}</div>
      </div>

      <div className="hidden md:flex items-center gap-3">
        {isLoggedIn ? (
          <>
            <div className="text-xs text-left text-blue-300">{userName}</div>
            <button
              onClick={handleLogout}
              className="p-2 mt-2 rounded-md bg-blue-600 hover:bg-blue-700 transition"
              title="Logout"
            >
              ⏻
            </button>
          </>
        ) : (
          <>
            <button
              onClick={() => navigate("/login")}
              className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
            >
              Login
            </button>
          </>
        )}
      </div>

      <button
        onClick={() => setIsMobileMenuOpen((s) => !s)}
        className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-blue-300 bg-blue-500"
        aria-label="Toggle menu"
      >
        {isMobileMenuOpen ? "×" : "☰"}
      </button>
    </header>

    {/* Mobile menu content */}
    {isMobileMenuOpen && (
      <div className="md:hidden bg-[#2a0f2f] border-b border-blue-800 px-4 py-2 animate-fadeIn">
        {isLoggedIn ? (
          <div className="flex flex-row items-center justify-center gap-3">
            <span className="text-blue-300 text-xs lg:text-sm whitespace-nowrap h-7">
              {userName}
            </span>
            <button
              onClick={handleLogout}
              className="rounded-md bg-blue-600 hover:bg-blue-700 w-7 h-7 flex items-center justify-center text-white"
              title="Logout"
            >
              ⏻
            </button>
          </div>
        ) : (
          <div className="flex flex-row items-center justify-center gap-6">
            <Link to="/login" className="text-blue-300 hover:text-yellow-300">
              Login
            </Link>
          </div>
        )}
      </div>
    )}

    <div className="flex-1 bg-black py-1">
      <div className="bg-black border border-gray-700 shadow-lg rounded-2xl p-4 mx-auto">
        <div className="flex justify-between mb-2">
          <h2 className="text-lg font-semibold text-yellow-200 flex items-center gap-2">
            <FontAwesomeIcon icon={faSearch} />
            Advanced Search
          </h2>
          <button
            onClick={toggleSearch}
            className="text-white text-sm w-40 flex items-end gap-1 hover:text-blue-300"
          >
            {showSearch ? "Hide" : "Show"} Search
            <FontAwesomeIcon icon={faSlidersH} />
          </button>
        </div>

        {showSearch && (
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-center gap-4">
            <div className="flex flex-col gap-3 w-full lg:w-1/2 bg-gray-900 p-4 rounded-lg">
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <FontAwesomeIcon icon={faCalendarAlt} className="text-pink-400" />
                  <DatePicker
                    selected={fromDate}
                    onChange={setFromDate}
                    placeholderText="From Date"
                    className="bg-gray-800 text-pink-300 px-3 py-1 rounded focus:outline-none w-full"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <FontAwesomeIcon icon={faCalendarAlt} className="text-pink-400" />
                  <DatePicker
                    selected={toDate}
                    onChange={setToDate}
                    placeholderText="To Date"
                    className="bg-gray-800 text-pink-300 px-3 py-1 rounded focus:outline-none w-full"
                  />
                </div>
              </div>
              <input
                type="text"
                placeholder="Enter Tags"
                value={tags}
                onChange={(e) => setTags(e.target.value)}
                className="bg-gray-800 text-pink-300 px-3 py-2 rounded focus:ring-2 focus:ring-pink-400 focus:outline-none w-full"
              />
            </div>

            {Object.keys(filters).length > 0 && (
              <div className="flex flex-col gap-3 w-full lg:w-1/2 bg-gray-900 p-4 rounded-lg">
                <h3 className="text-yellow-200 font-semibold text-center mb-2">
                  Additional Filters
                </h3>
                <div className="flex flex-col w-full gap-2 place-items-center">
                  {Object.keys(filters).map((key) => (
                    <input
                      key={key}
                      type="text"
                      name={key}
                      placeholder={key.replace(/([A-Z])/g, " $1").trim()}
                      value={filters[key]}
                      onChange={handleFilterChange}
                      className="bg-gray-800 text-pink-300 w-full px-3 py-2 rounded focus:ring-2 focus:ring-pink-400 focus:outline-none"
                    />
                  ))}
                </div>
              </div>
            )}
            <div className="flex justify-center mt-4 gap-3 flex-wrap">
              <button
                onClick={() => handleSearch({ fromDate, toDate, tags, ...filters })}
                className="flex items-center justify-center gap-2 w-40 bg-pink-700 text-black font-semibold px-4 py-2 rounded hover:bg-pink-600 transition"
              >
                <FontAwesomeIcon icon={faSearch} />
                Search
              </button>
            </div>
          </div>
        )}
      </div>      
      <div className=" text-white p-4 mt-4">
        <div className="mt-2">
          {tasks && tasks.length !== 0 && (
            <div className="flex justify-between items-center">
              <h3 className="text-sm mt-1 mx-1 text-yellow-200">
                {tasks.length} {purposeHead} Record(s) Found!
              </h3>
              <Link
                to={`/tasks/add/${purposeHead}`}
                className="h-10 px-4 py-2 bg-blue-700 rounded-lg flex items-center gap-2 text-white font-medium"
              >
                <FontAwesomeIcon icon={faPlus} />
                Add New
              </Link>
            </div>
          )}
        </div>
        {loading ? (
          <Loader />
        ) : (
          <div>
            {tasks && tasks.length === 0 ? (
              <div className='h-[300px] flex items-center justify-center gap-4 text-yellow-300 mb-2'>
                <div className="flex flex-col justify-between items-center">
                  <h3 className='text-lg mt-1 mx-2 text-orange-400'>No Record Found!</h3>
                  <Link to={`/tasks/add/${purposeHead}`} className='block w-full h-full px-1 py-2 ml-4 bg-blue-500 rounded-lg'>
                    <FontAwesomeIcon className="bg-blue-700" icon={faPlus} />  Add New
                  </Link>
                </div>
              </div>
            ) : (
              sortedTasks.map((task, index) => (
                <div key={task._id} className='bg-black border border-gray-600 py-2 px-4 text-gray-100 rounded-md shadow-md text-sm mt-4'>
                  <div className='flex'>
                    <span className='font-medium'>{index + 1}{'. '}{task.title}{', '}({formatDateTime(task.taskDate)})</span>
                    <Tooltip text={"View details"} position={"top"}>
                      <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(task._id)}>
                        <i className="fa-solid fa-eye"></i>
                      </span>
                    </Tooltip>
                    <Tooltip text={"Edit this record"} position={"top"}>
                      <Link to={`/tasks/${task._id}`} className='mr-4 text-blue-600 cursor-pointer'>
                        <i className="fa-solid fa-pen"></i>
                      </Link>
                    </Tooltip>
                    <Tooltip text={"Delete this record"} position={"top"}>
                      <span className='text-red-500 cursor-pointer mr-2' onClick={() => deleteClicked(task._id)}>
                        <i className="fa-solid fa-trash"></i>
                      </span>
                    </Tooltip>
                  </div>
                  {selectedTaskId === task._id && (
                    <div className='bg-black border border-blue-300 rounded-sm p-4 text-white mt-2'>
                      <p className='text-white justify-center text-m mt-2 mb-2'>
                        <h2 className='text-yellow-400 text-m lg:text-lg'><strong>{task.purpose.charAt(0).toUpperCase() + task.purpose.slice(1)} Details</strong></h2>
                      </p>
                      <p className='text-yellow-200'><strong>Task Code:</strong> {task.taskCode}</p>

                      <p><strong>Chronicle Entry is about:</strong> {task.purpose}</p>
                      <p><strong>Sharable Chronicle Code:</strong> {task.taskCode}</p>
                      <p><strong>Title:</strong> {task.title}</p>
                      <p><strong>Description:</strong> {task.description}</p>
                      <p><strong>Category:</strong> {task.category}</p>
                      <p><strong>Sub-category:</strong> {task.subcategory}</p>
                      <p><strong>Current Status:</strong> {task.currentStatus}</p>
                      <p><strong>Important:</strong> {task.isFlagged ? "Yes":"No"}</p>

                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Additional Details</strong>
                      </p>
                      <p><strong>Name:</strong> {task.name}</p>
                      <p><strong>Place:</strong> {task.place}</p>
                      <p><strong>Amount:</strong> {task.currency} {task.amount}</p>
                      <p><strong>Qty:</strong> {task.qty} {task.unit}</p>

                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Dates</strong>
                      </p>                        
                      <p><strong>Date:</strong> {formatDateTime(task.taskDate)}</p>
                      <p><strong>End Date:</strong> {task.endDate == '' ? "No End Date" : formatDateTime(task.endDate)}</p>
                      <p><strong>Time / Start Time:</strong> {task.startTime}</p>
                      <p><strong>End Time:</strong> {task.endTime}</p>
                      
                      <p><strong>Tags:</strong> {task.tags}</p>
                      <p><strong>Remarks:</strong> {task.remarks}</p>
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Diary & Journal</strong>
                      </p>
                      <p><strong>Saved in Diary:</strong> {task.isDiary ? "Yes":"No"}</p>
                      <p><strong>Diary Type:</strong> {task.diaryType}</p>
                      <p><strong>Saved in Journal:</strong> {task.isJournal ? "Yes":"No"}</p>
                      <p><strong>Journal Type:</strong> {task.journalType}</p>
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Secret</strong>
                      </p>
                      <p><strong>Is Secret:</strong> {task.isSecret ? "Yes":"No"}</p>
                      <p><strong>Secret Key:</strong> {task.secretKey}</p>
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Visibility</strong>
                      </p>
                      <p><strong>Is Public:</strong> {task.isPublic ? "Yes":"No"}</p>
                      <p><strong>Is Shared:</strong> {task.isShared ? "Yes":"No"}</p>
                      <p><strong>Pair Code:</strong> {task.pairCode}</p>
                      <p><strong>Team Code:</strong> {task.teamCode}</p>
                      <p><strong>Project Code:</strong> {task.projectCode}</p>
                      <p><strong>Process Code:</strong> {task.processCode}</p>
                      <p><strong>Location Code:</strong> {task.factoryCode}</p>
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Linked</strong>
                      </p>
                      <p><strong>Linked RCA Code:</strong> {task.rcaCode}</p>
                      <p><strong>Linked LC Code:</strong> {task.taskLinkCode}</p>
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Kaizen: </strong> {task.isKaizen ? "Yes":"No"}
                      </p>
                      {task.isKaizen && (
                        <>
                        <p><strong>Kaizen Category:</strong> {task.kaizenCategory}</p>
                        <p><strong>Kaizen Code:</strong> {task.kaizenCode}</p>
                        </>
                      )}
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Ikigai: </strong>{task.isIkigai ? "Yes":"No"}
                      </p>
                      {task.isIkigai && (
                        <>
                        <p><strong>Ikigai Piller:</strong> {task.ikigaiP}</p>
                        <p><strong>Ikigai Code:</strong> {task.ikigaiCode}</p>
                        </>
                      )}
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Sustainable Goal</strong> {task.isSugo ? "Yes":"No"}
                      </p>
                      {task.isSugo && (
                        <>
                        <p><strong>SUGO Category:</strong> {task.sugoCategory}</p>
                        <p><strong>SUGO Code:</strong> {task.sugoCode}</p>
                        </>
                      )}
                      <p><strong>Target CO2 Reduction:</strong> {task.targetReduction.toFixed(2)}</p>
                      <p><strong>I Am True to Report my CO2 reduction:</strong> {task.iAmTrue ? 'Yes' : 'No'}</p>

                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Completion</strong>
                      </p>
                      <p><strong>Is To-Do:</strong> {task.isToDo ? 'Yes' : 'No'}</p>
                      <p><strong>Is Done:</strong> {task.isDone ? 'Yes' : 'No'}</p>
                      <p><strong>Actual Date of Compeltion:</strong> {task.actualDate ? formatDateTime(task.actualDate) : 'N/A'}</p>
                      <p><strong>Days Difference:</strong> {task.daysDiff.toFixed(2)}</p>

                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Linked People, Project, Processes, Machines</strong>
                      </p>                        
                      <p><strong>Is Pair:</strong> {task.isPair ? 'Yes' : 'No'}</p>
                      <p><strong>Is Team:</strong> {task.isTeam ? 'Yes' : 'No'}</p>
                      <p><strong>Is Project:</strong> {task.isProject ? 'Yes' : 'No'}</p>
                      <p><strong>Is Process:</strong> {task.isProcess ? 'Yes' : 'No'}</p>
                      <p><strong>Is Location:</strong> {task.isLocation ? 'Yes' : 'No'}</p>

                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Focus Timer:</strong> {task.isFocusTimer ? 'Yes' : 'No'}
                      </p>    
                      { task.isFocusTimer && (
                        <>                    
                        <p><strong>Is Life Chunk:</strong> {task.isLifeChunk ? 'Yes' : 'No'}</p>
                        <p><strong>Life Chunk Code:</strong> {task.lifeChunkCode}</p>
                        </>
                      )}
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Risk Analysis:</strong> {task.isRisk ? 'Yes' : 'No'}
                      </p>
                      {task.isRisk && (
                        <>
                        <p></p>
                        <p><strong>Risk Title:</strong> {task.riskTitle}</p>
                        <p><strong>Risk Likelihood:</strong> {task.riskLikelihood}</p>
                        <p><strong>Risk Impact:</strong> {task.riskImpact}</p>
                        <p><strong>Risk Score:</strong> {task.riskScore.toFixed(2)}</p>
                        <p><strong>Risk Level:</strong> {task.riskLevel}</p>
                        <p><strong>Risk Mitigations:</strong> {task.riskMitigations}</p>
                        <p><strong>Risk Remarks:</strong> {task.riskRemarks}</p>
                        </>
                      )}
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Opportunity Check:</strong> {task.isOpportunity ? 'Yes' : 'No'}
                      </p>
                      {task.isOpportunity && (
                        <>
                        <p><strong>Opportunity Title:</strong> {task.oppTitle}</p>
                        <p><strong>Opportunity Passion Score:</strong> {task.oppPassionScore.toFixed(2)}</p>
                        <p><strong>Opportunity Profit Score:</strong> {task.oppProfitScore.toFixed(2)}</p>
                        <p><strong>Opportunity Score:</strong> {task.oppScore.toFixed(2)}</p>
                        <p><strong>Opportunity Comment:</strong> {task.oppComment}</p>
                        <p><strong>Opportunity Remarks:</strong> {task.oppRemarks}</p>
                        </>
                      )}
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Attendance:</strong>
                      </p>
                      { task.purpose === "Attendance" && (
                        <>
                        <p><strong>Whose Attendance:</strong> {task.whoseAttendance}</p>
                        <p><strong>Attendee Name:</strong> {task.attendeeName}</p>
                        <p><strong>Attendance Status:</strong> {task.attendanceStatus}</p>
                        <p><strong>Scheduled Right Time:</strong> {task.rightTime}</p>
                        <p><strong>Grace Time (in Minutes):</strong> {task.graceTime}</p>
                        <p><strong>Time In:</strong> {task.timeIn}</p>
                        <p><strong>In Time Status:</strong> {task.inTimeStatus}</p>
                        <p><strong>Time Out:</strong> {task.timeOut}</p>     
                        <p><strong>Out Time Status:</strong> {task.outTimeStatus}</p>
                        </>
                      )}
                      { task.purpose === "Subscription" && (
                        <>
                        <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                          <strong>Subscription:</strong>
                        </p>
                        <p><strong>Subscription Period:</strong> {task.subscriptionPeriod}</p>
                        </>
                      )}
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Life Resources:</strong>
                      </p>
                      { task.purpose === "Liferesources" && (
                        <>
                        <p><strong>Type:</strong> {task.lrType}</p>
                        <p><strong>Amount:</strong> {task.lrAmount.toFixed(2)}</p>
                        <p><strong>Particulars:</strong> {task.lrParticulars}</p>
                        </>
                      )}
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Couple/Mates:</strong>
                      </p>
                      { task.diaryType === "Couple" && (
                        <>
                        <p><strong>Couple Act:</strong> {task.coupleAct}</p>
                        <p><strong>Couple Sub Act:</strong> {task.coupleSubAct}</p>
                        <p><strong>Couple Act Time:</strong> {task.coupleActTime}</p>
                        <p><strong>Couple Act Duration:</strong> {task.coupleActDuration.toFixed(2)}</p>
                        <p><strong>Couple Act Special Remarks:</strong> {task.coupleActSplRemarks}</p>
                        </>
                      )}
                      <p className='text-yellow-200 justify-center text-m mt-2 mb-2 py-2'>
                        <strong>Vaccination</strong>
                      </p>
                      { task.purpose === "Liferesources" && task.vaccineName && (
                        <>
                        <p><strong>Vaccine Name:</strong> {task.vaccineName}</p>
                        </>
                      )}
                      <p><strong>Date Created:</strong> {task.dateCreated ? formatDateTime(task.dateCreated) : 'N/A'}</p>
                      <p><strong>Created By:</strong> {task.createdBy}</p>                   
                      <Tooltip text={"Share"} position={"top"}>
                        <span className='text-green-500 cursor-pointer mr-4' onClick={() => handleTaskShare(task._id)}>
                          <i className="fa-solid fa-share"></i>
                        </span>
                      </Tooltip>
                      <Tooltip text={"Save"} position={"top"}>
                        <span className='text-blue-500 cursor-pointer mr-4' onClick={() => handleTaskSave(task._id)}>
                          <i className="fa-solid fa-save"></i>
                        </span>
                      </Tooltip>
                      <Tooltip text={"Print"} position={"top"}>
                        <span className='text-orange-500 cursor-pointer mr-4' onClick={() => handleTaskPrint(task._id)}>
                          <i className="fa-solid fa-print"></i>
                        </span>
                      </Tooltip>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        )}
      </div>

      {isDeleteClicked && taskToDelete && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
        >
          <div className="w-6/12 flex flex-row justify-center bg-blue-200 text-black border-b border-gray-300 p-4">
            <button
              className="bg-red-700 w-40"
              onClick={() => handleDelete(taskToDelete)}
              style={{ maxWidth: "150px" }}
            >
              Confirm To Delete
            </button>
            <button
              className="bg-yellow-300 ml-4 text-black w-40"
              onClick={() => noDeleteClicked()}
              style={{ maxWidth: "150px" }}
            >
              No I Do Not Want To Delete
            </button>
          </div>
        </div>
      )}
    </div>

    <footer className="bg-black border-t border-blue-800 text-white py-4 mt-auto">
      <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
        <div className="text-xs lg:text-sm">
          © 2025 Think5Whys Global DeepTech Solutions.
        </div>
        <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
          <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
          <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
          <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
          <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
        </div>
      </div>
    </footer>
  </div>
 )
}

export default TaskList